import React from 'react'
import { Link, GatsbyLinkProps } from 'gatsby'
import styled from "styled-components"

import { Text } from "components/shared/base"
interface OwnProps {
  color?: string,
  externalLink: false,
  href: GatsbyLinkProps<{}>['to'],
  text: string
}

export type TextLinkProps = OwnProps

const LinkHoverStyles = `
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
const StyledLink = styled(Link)`
  color: ${props => props.color || props.theme.colors.linkPrimary};
  ${LinkHoverStyles}
`;

const StyledExternalLink = styled(Text)`
  color: ${props => props.color || props.theme.colors.linkPrimary};
  ${LinkHoverStyles}
`;

const TextLink: React.FC<OwnProps> = ({
  color,
  externalLink,
  href,
  text
}): React.ReactElement => {
  return (
    <>
      { externalLink ?
        <StyledExternalLink as="a" color={color} href={href}>{text}</StyledExternalLink> :
        <StyledLink color={color} to={href}>{text}</StyledLink>
      }
    </>
  )
}

export default TextLink
